import { data } from '@core/Services/Analytics/helpers/dataLayer'
import { keys } from '@core/Services/Analytics/keys'
import { trackEvent, trackKey } from '@core/Services/Analytics/track'

export const trackLoginSuccess = (
  accountNumber: string,
  keepLoggedIn: boolean,
  rememberAccount: boolean,
  isBioAuthUsed: boolean
) => {
  trackEvent(keys.loginSuccess, {
    accountNumber,
    keepLoggedIn,
    rememberAccount,
    isBioAuthUsed,
  })
}

export const trackLoginFailed = (accountIdentifier: string) => {
  trackEvent(keys.loginFailed, { accountIdentifier })
}

export const trackLogout = () => {
  const accountNumber = data.user.accountNumber
  trackEvent(keys.logout, { accountNumber })
}

export const trackLoginForgotPassword = (accountIdentifier: string) =>
  trackEvent(keys.loginForgotPassword, { accountIdentifier })

export const trackLoginForgotAccountNumber = () => trackKey(keys.loginForgotAccountNumber)
export const trackLoginForgotAccountNumberSent = (deliveryMethod: string) =>
  trackEvent(keys.loginForgotAccountNumberSent, { deliveryMethod })
export const trackLoginResetPasswordSuccess = (accountNumber: string, deliveryMethod: string) =>
  trackEvent(keys.loginResetPasswordSuccess, { accountNumber, deliveryMethod })
